import { zonoApi } from '../api/zonoApi';
import {
  CreatePriceListRequest,
  PriceListDetailsRequest,
  PriceListDetailsResponse,
  PriceListRequest,
  PriceListResponse,
} from './price-list-model';

export const PriceListApi = zonoApi.injectEndpoints({
  endpoints: (builder) => ({
    priceListDetails: builder.query<
      PriceListDetailsResponse,
      PriceListDetailsRequest
    >({
      query: (args) => ({
        url: `hub/commerce-v2/pricing/customer/details/${args.workspaceId}`,
        method: 'GET',
        params: args.params,
      }),
    }),
    createPriceList: builder.mutation<any, CreatePriceListRequest>({
      query: (args) => {
        const { sellerWorkspaceId } = args;
        return {
          url: `hub/commerce-v2/pricing/${sellerWorkspaceId}`,
          method: 'POST',
          body: args,
        };
      },
    }),
    getWorkspacePricelist: builder.mutation<
      PriceListResponse,
      { priceListRequest: PriceListRequest }
    >({
      query: (args) => {
        const { priceListRequest } = args;
        return {
          url: `hub/commerce-v2/pricing/all/${priceListRequest.sellerWorkspaceId}`,
          method: 'POST',
          body: priceListRequest,
        };
      },
    }),
  }),
});

export const {
  useLazyPriceListDetailsQuery,
  useCreatePriceListMutation,
  useGetWorkspacePricelistMutation,
} = PriceListApi;
